module.exports = __webpack_public_path__ + "images/Tick.0b62a636082e763f58ca71eebce74359.png";